import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { experimental_sx as sx } from '@mui/system';

export const RadiusButton = styled(Button)(
  sx({
    borderRadius: '100px',
    px: 3,
  })
)